import { createPinia } from 'pinia'
export * from './modules/user'



const pinia = createPinia()

export default pinia;